import PlacesRegister from "./PlacesRegister";

export default PlacesRegister;
